<template>
  <transition name="test">
    <article v-if="allReady" class="post">
    <component :is="post" />
    </article>
  </transition>
</template>

<script>
// import VueDisqus from 'vue-disqus/VueDisqus'
import { kebabify, prettyDate } from '../helpers'

export default {
  name: 'blog-post',
  resource: 'BlogPost',
  components: {
    SexEd: () => import("./SexEd"),
    Piano: () => import("./Piano"),
    Resilience: () => import("./Resilience"),
    ZoomAttentionSpanPart1: () => import("./ZoomAttentionSpanPart1"),
    ZoomAttentionSpanPart2: () => import("./ZoomAttentionSpanPart2"),
    ZoomAttentionSpanPart3: () => import("./ZoomAttentionSpanPart3"),
    ZoomAttentionSpanPart4: () => import("./ZoomAttentionSpanPart4")
  },
  props: { post: String },

  data() {
    return {
      ready: false
    }
  },

  computed: {
    allReady() {
      return this.ready && this.post;
    }
  },

  watch: {
    post(to, from) {
      if (to === from || !this.post) return;

      this.commentsReady = false
      // this.$getResource('post', to)
      //   .then(this.showComments)
      //   .then(() => {
      //     this.ready = true;
      //   });
    }
  },

  methods: {
    kebabify,
    prettyDate
  },

  mounted() {
    if (!this.post) {
      this.ready = true;
      return;
    }

    this.ready = true;

    // this.$getResource('post', this.post)
    //   .then(this.showComments)
    //   .then(() => {
    //     this.ready = true;
    //   });
  }
}
</script>
